"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var application_1 = require("../../models/application");
var constants = require("../../shared/code/Constants");
function view() {
    var _this = this;
    return {
        state: {
            actionItem: this.props.actionItem,
            parentTag: "",
            constants: constants
        },
        initialize: function () {
            _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {},
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.NoteResultData();
                resultData.actionId = _this.view.state.actionItem.id;
                resultData.type = application_1.ActionType.note;
                _this.props.onDataChanged(resultData);
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowNoteAction/View.js
// module id = 579
// module chunks = 0